/**
 * Iron Play Intervention Reducers
 */
import {
    RANGEIRONPLAY_ACTION,
    FETCH_RANGEIRONPLAY,
    ADD_RANGEIRONPLAY,
    GET_RANGEIRONPLAY,
    EDIT_RANGEIRONPLAY,
    DELETE_RANGEIRONPLAY,
    RANGEFAIRWAY_ACTION,
    FETCH_RANGEFAIRWAY,
    ADD_RANGEFAIRWAY,
    GET_RANGEFAIRWAY,
    EDIT_RANGEFAIRWAY,
    DELETE_RANGEFAIRWAY,
    RANGEDRIVER_ACTION,
    FETCH_RANGEDRIVER,
    ADD_RANGEDRIVER,
    GET_RANGEDRIVER,
    EDIT_RANGEDRIVER,
    DELETE_RANGEDRIVER,
    RANGESPECIALITY_ACTION,
    FETCH_RANGESPECIALITY,
    ADD_RANGESPECIALITY,
    GET_RANGESPECIALITY,
    EDIT_RANGESPECIALITY,
    DELETE_RANGESPECIALITY,
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    rangeironplaylist:[],
    particularrangeplay:[],
    rangefairwaylist:[],
    particularrangefairway:[],
    rangedriverlist:[],
    particularrangedriver:[],
    rangespeciallist:[],
    particularrangespecial:[],
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case RANGEIRONPLAY_ACTION:
            return { ...state, loading: true };
 
        case FETCH_RANGEIRONPLAY:
            return { ...state, loading: false, rangeironplaylist: action.payload };  
            
        case ADD_RANGEIRONPLAY:
            return { ...state, loading: false };    

        case GET_RANGEIRONPLAY:
            return { ...state, loading: false, particularrangeplay: action.payload };  
            
        case EDIT_RANGEIRONPLAY:
            return { ...state, loading: false }; 
            
        case DELETE_RANGEIRONPLAY:
            return { ...state, loading: false };   
            
        case RANGEFAIRWAY_ACTION:
            return { ...state, loading: true };
    
        case FETCH_RANGEFAIRWAY:
            return { ...state, loading: false, rangefairwaylist: action.payload };  
            
        case ADD_RANGEFAIRWAY:
            return { ...state, loading: false };    

        case GET_RANGEFAIRWAY:
            return { ...state, loading: false, particularrangefairway: action.payload };  
            
        case EDIT_RANGEFAIRWAY:
            return { ...state, loading: false }; 
            
        case DELETE_RANGEFAIRWAY:
            return { ...state, loading: false };    
        
        case RANGEDRIVER_ACTION:
            return { ...state, loading: true };
    
        case FETCH_RANGEDRIVER:
            return { ...state, loading: false, rangedriverlist: action.payload };  
            
        case ADD_RANGEDRIVER:
            return { ...state, loading: false };    

        case GET_RANGEDRIVER:
            return { ...state, loading: false, particularrangedriver: action.payload };  
            
        case EDIT_RANGEDRIVER:
            return { ...state, loading: false }; 
            
        case DELETE_RANGEDRIVER:
            return { ...state, loading: false };   

        case RANGESPECIALITY_ACTION:
            return { ...state, loading: true };
    
        case FETCH_RANGESPECIALITY:
            return { ...state, loading: false, rangespeciallist: action.payload };  
            
        case ADD_RANGESPECIALITY:
            return { ...state, loading: false };    

        case GET_RANGESPECIALITY:
            return { ...state, loading: false, particularrangespecial: action.payload };  
            
        case EDIT_RANGESPECIALITY:
            return { ...state, loading: false }; 
            
        case DELETE_RANGESPECIALITY:
            return { ...state, loading: false };   

         default: return { ...state };
     }
 }